import isEqual from 'lodash/isEqual';
import type {ExpressionV4, MetadataExports} from '../types';
import {getExpressionExportProps} from './getExpressionExportProps';

export const updateExpressionExportProps = (
  expression: ExpressionV4,
  currentExports: MetadataExports | undefined,
): MetadataExports => {
  const newProps = getExpressionExportProps(expression);
  return currentExports
    ? isEqual(currentExports.expressions[expression.id], newProps)
      ? currentExports
      : {
          ...currentExports,
          expressions: {
            ...currentExports.expressions,
            [expression.id]: newProps,
          },
        }
    : {
        work: {
          type: 'BOOK',
        },
        expressions: {
          [expression.id]: newProps,
        },
        manifestations: {},
      };
};
